import {
  AllAmenitiesViewModel,
  AmenityViewModel,
  HighlightAmenitiesViewModel,
  PropertyAdditionalInfoViewModel,
  PropertyInfoSectionViewModel,
  PropertyInfoSubSectionViewModel,
  FormattedViewModel,
  SectionType,
  TextType,
} from 'models';

export function hasAmenities(propertyInfo: any) {
  return propertyInfo.summary?.amenities;
}

export function adaptAmenities(amenities: any): AllAmenitiesViewModel {
  const topSummary = amenities && amenities.top ? adaptAmenityViewModel(amenities.top) : null;
  const highlightAmenities =
    amenities && amenities.takeover && amenities.takeover.highlight ? adaptHighlightAmenities(amenities.takeover?.highlight) : null;

  return {
    topSummary,
    highlightAmenities,
  } as AllAmenitiesViewModel;
}

export function adaptAmenityViewModel(amenities: any): AmenityViewModel[] {
  return amenities.map(
    amenity =>
      ({
        description: amenity.text,
        icon: amenity.icon?.id?.toLowerCase(),
      } as AmenityViewModel)
  );
}

export function adaptHighlightAmenities(highlightAmenities): HighlightAmenitiesViewModel[] {
  return highlightAmenities.map(
    amenity =>
      ({
        label: '',
        sections: adaptAmenityViewModel(amenity.items),
        title: amenity.heading,
      } as HighlightAmenitiesViewModel)
  );
}

export function updateAdditionalInfo(additionalInfo: any, amenities: any): PropertyAdditionalInfoViewModel {
  if (!amenities) {
    return additionalInfo;
  }
  const [propertyAmenities, roomAmenities] = amenities;
  additionalInfo.propertyAmenitiesSection = propertyAmenities
    ? adaptPropertyInfoSectionViewModel(propertyAmenities)
    : additionalInfo.propertyAmenitiesSection;
  additionalInfo.roomAmenitiesSection = roomAmenities
    ? adaptPropertyInfoSectionViewModel(roomAmenities)
    : additionalInfo.roomAmenitiesSection;

  return additionalInfo;
}

export function adaptPropertyInfoSectionViewModel(section: any): PropertyInfoSectionViewModel {
  return {
    title: section.title,
    sections: adaptPropertyInfoSubSectionViewModel(section.contents),
    dataLabel: section.dataLabel,
  } as PropertyInfoSectionViewModel;
}

export function adaptPropertyInfoSubSectionViewModel(subSections: any): PropertyInfoSubSectionViewModel[] {
  return subSections.map(subSection => {
    const descriptions = subSection.items.map(item => item.text);
    const formattedDescriptions = subSection.items.map(
      item =>
        ({
          description: item.text,
          sectionType: SectionType.PLAIN_LIST,
          textType: TextType.PLAIN_TEXT,
        } as FormattedViewModel)
    );

    return {
      title: subSection.heading,
      icon: subSection.icon?.id,
      body: descriptions,
      formattedDescriptions,
    } as PropertyInfoSubSectionViewModel;
  });
}
